export default {
  state: {
    locations: [],
    loading: false,
  },
  getters: {
    locations: state => state.locations,
    loading: state => state.loading,
  },
  mutations: {
    setLocations(state, locations) {
      state.locations = locations;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const locations = await axios.get('api/locations');
        commit('setLocations', locations);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/locations/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
        await axios.post('api/locations', payLoad);
    },

    async update({ commit }, payLoad) {
        await axios.put('api/locations', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/locations/' + id);
    }
  },
};
